<template>
  <div class="block mobileFull">
    <div class="col-md-6 col-sm-6 p-x-n mobileLeft">
      <product-gallery :images="product.images"></product-gallery>
    </div>
    <div class="col-md-6 col-sm-6 mobileRight p-x-n">
      <div class="margin_left">
        <!--<div class="product-brand">-->
        <!--<span class="pull-left">{{product.brand}}</span>-->
        <!--<rating class="pull-left" :value="3" :ratingHeight="10"></rating>-->
        <!--({{product.view_count}})-->
        <!--</div>-->

        <h3 class="product-name">
          <span v-if="productOwner">
            <span @click="goToProductOwner(productOwner.slug)" style="cursor: pointer;">
              {{ productOwner.public_identity }} |
            </span>
          </span> {{ product.name }}
        </h3>

        <div class="product-model">
          <span class="product-model-label">Model</span>
          {{ product.model }}
        </div>

        <div class="product-prices p-y-n">
          <div class="product-price" v-if="product.price">
            RM
            {{
              priceFormat(
                product.discount_price ? product.discount_price : product.price
              )
            }}
            <span class="product-unit">{{
              product.unit_of_measure ? '/' + product.unit_of_measure : ''
            }}</span>
          </div>
          <div class="product-old-price" v-if="product.discount_price">
            <span class="product-old-price-number"
              >RM {{ priceFormat(product.price) }}</span
            >
            <span
              >({{ calcOffDiscount(product.price, product.discount_price) }} %
              off)</span
            >
          </div>
        </div>

        <div
          class="product-stock-status product-stock-status-out"
          v-if="product.quantity == 0"
        >
          Out of stock
        </div>

        <div class="product-tags m-t m-b-md">
          <span
            class="product-tag m-b-xxs m-r-x"
            v-for="(tag, i) of product.tags"
            @click="goToProductList(tag)"
            :key="i"
          >
            #{{ tag }}
          </span>
        </div>

        <div v-if="10 === product.status && isShopAvailable()">
          <div>
            <div class="product-buttons">
              <a :href="productBuyLink(product.id)" target="_blank">
                <button
                  class="
                    btn btn--red
                    text-uppercase
                    font-weight-normal
                    mt-3
                    product-action-btn
                  "
                >
                  Buy now
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Rating from './rating'
import ProductGallery from './product-gallery'
import ApiService from "../../../services/ApiService";

export default {
  name: 'product-full-view',
  props: {
    product: null,
  },
  components: {
    Rating,
    ProductGallery,
  },
  data() {
    return {
      productOwner: null,
      accountService: new ApiService(
        process.env.ACCOUNT_URL,
        window.user.oauth_token
      )
    };
  },
  mounted() {
    console.log(this.product);
    this.fetchOwner(this.product.user_id);
  },
  methods: {
    calcOffDiscount(price, discount_price) {
      return 100 - Math.round((discount_price / price) * 100)
    },
    priceFormat(price) {
      return price.toLocaleString('en', { minimumFractionDigits: 2 })
    },
    productBuyLink(id) {
      return `${window.marketplace.url}/cart/buy-now/${id}?quantity=1`
    },
    goToProductList(tag) {
      window.location.assign(
        `${window.user.community_url}/${window.user.community_domain}/mp?tags=${tag}`
      )
    },
    goToProductOwner(slug) {
      window.location.assign(
        `${window.user.community_url}/${window.user.community_domain}/profiles/view/${slug}?type=products`
      )
    },
    isShopAvailable() {
      return (
        typeof window.marketplace.apiUrl !== 'undefined' &&
        typeof window.marketplace.store_id !== 'undefined' &&
        typeof window.marketplace.url !== 'undefined'
      )
    },
    fetchOwner(id){
      this.accountService.get(`/api/profiles/` + id).then(res => {
        this.productOwner = res.data;
      });
    }
  },
}
</script>

<style lang="scss" scoped>
* {
  font-family: Roboto, 'Helvetica Neue', Helvetica, Arial, sans-serif;
}
.lazy-image-placeholder {
  background-position: center center;
  background-repeat: no-repeat;
  background-size: auto;
}
.product-brand {
  font-family: Roboto;
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 1.54366px;
  color: #888;
}
.product-name {
  margin-top: 0;
  font-size: 14px;
  font-weight: 300;
}
.product-model {
  margin: 8px 0;
}
.product-model-label {
  color: #666;
}
.product-current-price {
  font-weight: 500;
  font-size: 1rem;
}
.product-unit {
  font-weight: normal;
  font-size: 0.8rem;
  color: #888;
}
.product-old-price {
  font-weight: 300;
  font-size: 0.8rem;
  color: #888;
}
.product-old-price-number {
  text-decoration: line-through;
}
.margin_left {
  margin-left: 36px;
}

@media only screen and (min-width: 1200px) {
  .product-name {
    color: rgba(0, 0, 0, 0.87);
    font-weight: 400;
  }
  .product-model {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.87);
    font-weight: 400;
  }
  .product-model-label {
    color: #666;
    font-size: 13px;
  }
  .product-price {
    font-size: 18px;
    color: rgba(0, 0, 0, 0.87);
    font-weight: 500;
  }
  .product-unit {
    font-size: 12px;
    color: #888;
    font-weight: 400;
  }
  .product-old-price {
    font-weight: 300;
    font-size: 12px;
    color: #888;
  }
  .product-tag {
    font-size: 11px;
    text-align: center;
    color: #555;
    border: 1px solid #bbb;
    padding: 2px 16px;
    border-radius: 2px;
    font-weight: 500;
    background-color: transparent;
    text-decoration: none;
    cursor: pointer;
    line-height: 16.5px;
    margin-right: 5px;
    display: inline-block;
    &:hover {
      background-color: #777;
      color: #fff;
      font-weight: 500;
    }
  }
  .product-action-btn {
    width: 195px;
  }
  .btn--red {
    background: #d0021b;
    color: #fff;
    font-size: 16px;
    line-height: 24px;
    line-height: 24px;
    font-weight: 400;
    box-shadow: none;
    border-radius: 0;
  }
}
@media only screen and (max-width: 1199px) and (min-width: 768px) {
  .product-name {
    color: rgba(0, 0, 0, 0.87);
    font-weight: 400;
  }
  .product-model {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.87);
    font-weight: 400;
  }
  .product-model-label {
    color: #666;
    font-size: 13px;
  }
  .product-price {
    font-size: 18px;
    color: rgba(0, 0, 0, 0.87);
    font-weight: 500;
  }
  .product-unit {
    font-size: 12px;
    color: #888;
    font-weight: 400;
  }
  .product-old-price {
    font-weight: 300;
    font-size: 12px;
    color: #888;
  }
  .product-tag {
    font-size: 11px;
    text-align: center;
    color: #555;
    border: 1px solid #bbb;
    padding: 2px 16px;
    border-radius: 2px;
    font-weight: 500;
    background-color: transparent;
    text-decoration: none;
    cursor: pointer;
    line-height: 16.5px;
    margin-right: 5px;
    display: inline-block;
    &:hover {
      background-color: #777;
      color: #fff;
      font-weight: 500;
    }
  }
  .product-action-btn {
    width: 195px;
  }
  .btn--red {
    background: #d0021b;
    color: #fff;
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
    box-shadow: none;
    border-radius: 0;
  }
}

@media only screen and (max-width: 360px) {
  .product-action-btn {
    width: 160px;
  }
}
@media only screen and (max-width: 767.98px) and (min-width: 481px) {
  .margin_left {
    margin-left: 15px;
  }
  .mobileFull {
    display: flex;
  }
  .mobileLeft {
    width: 50%;
  }
  .mobileRight {
    width: 50%;
  }
  .product-name {
    color: rgba(0, 0, 0, 0.87);
    font-weight: 400;
    // text-align: center;
  }
  .product-model {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.87);
    font-weight: 400;
    // text-align: center;
  }
  .product-model-label {
    color: #666;
    font-size: 13px;
  }
  .product-price {
    font-size: 17px;
    color: rgba(0, 0, 0, 0.87);
    font-weight: 500;
    // text-align: center;
  }
  .product-unit {
    font-size: 12px;
    color: #888;
    font-weight: 400;
    // text-align: center;
  }
  .product-old-price {
    font-weight: 300;
    font-size: 12px;
    color: #888;
    // text-align: center;
  }
  .product-tag {
    font-size: 11px;
    text-align: center;
    color: #555;
    border: 1px solid #bbb;
    padding: 2px 16px;
    border-radius: 2px;
    font-weight: 500;
    background-color: transparent;
    text-decoration: none;
    cursor: pointer;
    line-height: 16.5px;
    margin-right: 5px;
    display: inline-block;
    &:hover {
      background-color: #777;
      color: #fff;
      font-weight: 500;
    }
  }
  .product-action-btn {
    width: 195px;
  }
  .btn--red {
    background: #d0021b;
    color: #fff;
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
    box-shadow: none;
    border-radius: 0;
  }
  .product-buttons {
    // text-align: left;
  }
}
@media only screen and (max-width: 480.98px) {
  .mobileLeft {
    width: 100%;
  }
  .mobileRight {
    width: 100%;
  }
  .product-name {
    color: rgba(0, 0, 0, 0.87);
    font-weight: 400;
    text-align: center;
  }
  .product-model {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.87);
    font-weight: 400;
    text-align: center;
  }
  .product-model-label {
    color: #666;
    font-size: 13px;
  }
  .product-price {
    font-size: 17px;
    color: rgba(0, 0, 0, 0.87);
    font-weight: 500;
    text-align: center;
  }
  .product-unit {
    font-size: 12px;
    color: #888;
    font-weight: 400;
    text-align: center;
  }
  .product-old-price {
    font-weight: 300;
    font-size: 12px;
    color: #888;
    text-align: center;
  }
  .product-tag {
    font-size: 11px;
    text-align: center;
    color: #555;
    border: 1px solid #bbb;
    padding: 2px 16px;
    border-radius: 2px;
    font-weight: 500;
    background-color: transparent;
    text-decoration: none;
    cursor: pointer;
    line-height: 16.5px;
    margin-right: 5px;
    display: inline-block;
    &:hover {
      background-color: #777;
      color: #fff;
      font-weight: 500;
    }
  }
  .product-action-btn {
    width: 195px;
  }
  .btn--red {
    background: #d0021b;
    color: #fff;
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
    box-shadow: none;
    border-radius: 0;
  }
  .product-buttons {
    text-align: center;
  }
}
</style>
